import * as React from "react";

import { useTranslation } from "../../i18n/custom.i18n";
import i18next from "../../i18n/i18n.config";

import { parse_text_with_link } from "./details-utils"

// 1. Add language filter in link to library (link, browse and show similar items)
// 2. Fix details text for add-ins and posts

export const DescStation = (props: any) => {
    //console.log("daa", props);
    //console.log(window.Languages)

    const { t, i18n } = useTranslation();

    // TODO: how to implement Additive? Using TCA Tag (TagCamAdditive)
    // TODO: Use the language to forward to the correct page (CAM for en, es/CAM for spanish, etc)
    return (
        <>
            <p>
                {/* App + Robot | Apps | Robots */}             
                {
                /* RoboDK CAM - Additive */
                (props.data.hasOwnProperty("TCA") && (
                        (t('details-desc.station.cam-additive'))
                            .replace(/\{applicationscam\}/g, props.data["TCA"].map((application) => t('applicationcam.' + application)).join(", "))
                            .replace(/\{robots\}/g, props.data["RN"].join(", "))
                    )) || (props.data.hasOwnProperty("TCM") && (
                        (t('details-desc.station.cam-machining'))
                            .replace(/\{applicationscam\}/g, props.data["TCM"].map((application) => t('applicationcam.' + application)).join(", "))
                            .replace(/\{robots\}/g, props.data["RN"].join(", "))
                    )) || (props.data.hasOwnProperty("AP") && props.data.hasOwnProperty("RN") && (
                        (t('details-desc.station.apps-robots'))
                            .replace(/\{applications\}/g, props.data["AP"].map((application) => t('application.' + application)).join(", "))
                            .replace(/\{robots\}/g, props.data["RN"].join(", "))
                    ))
                }
                {
                (props.data.hasOwnProperty("TCA") || props.data.hasOwnProperty("TCM")) && (
                    <>
                    &nbsp;
                    <a href={"/" + (window.Languages.language == "en" ? "" : (window.Languages.language + "/")) + "CAM" }>
                    {(t('details-desc.station.cam-learnmore'))}
                    </a>
                    </>
                    )                                
                }
                {
                props.data.hasOwnProperty("AP") && !props.data.hasOwnProperty("RN") && (
                        (t('details-desc.station.apps'))
                            .replace(/\{applications\}/g, props.data["AP"].map((application) => t('application.' + application)).join(", "))
                    )
                }
                {
                !props.data.hasOwnProperty("AP") && props.data.hasOwnProperty("RN") && (
                        (t('details-desc.station.robots'))
                            .replace(/\{robots\}/g, props.data["RN"].join(", "))
                    )
                }
            </p>

            {/* Blog */}
            {
                props.data.hasOwnProperty("link") && props.data["link"].hasOwnProperty("blogs") && (
                    parse_text_with_link(
                        (t('details-desc.station.blog'))
                            .replace(/\{link\}/g, props.data["link"]["blogs"][0])
                    )
                )
            }
            {/* Videos */}
            {
                props.data.hasOwnProperty("link") && props.data["link"].hasOwnProperty("videos") && (
                    parse_text_with_link(
                        (t('details-desc.station.videos'))
                            .replace(/\{link\}/g, props.data["link"]["videos"][0])
                    )
                )
            }
            {/* Docs */}
            {
                props.data.hasOwnProperty("link") && props.data["link"].hasOwnProperty("docs") && (
                    parse_text_with_link(
                        (t('details-desc.station.docs'))
                            .replace(/\{link\}/g, props.data["link"]["docs"][0])
                    )
                )
            }

            {/* Browse */}
            {
                parse_text_with_link(
                    (t('details-desc.browse'))
                        .replace(/\{link\}/g, (window.Settings.LOCAL_BUILD)
                            ? "http://localhost:3002?Lang=" + window.Languages.language + "&n=" + props.data["F"].split(".", 1)[0]
                            : "/" + (window.Languages.language == "en" ? "" : (window.Languages.language + "/")) + "stations?n=" + props.data["F"].split(".", 1)[0])
                )
            }
        </>
    )
};
